import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseControl,
  Textbox,
  Custom,
  Dropdown,
  Container,
  FiltrosSelectores
} from '@app/shared';


@Injectable()
export class FiltersFormMasterFormService {
  constructor() { }

  /**
   * Retorna el formulario para agregar o editar un filtro
   *
   * @param {*} optionsOther
   * @param {*} templeteForm
   * @returns {BaseControl<any>[]}
   * @memberof FiltersFormMasterFormService
   */
  getFormFilter(optionsOther: any, templeteForm: any, data?: FiltrosSelectores): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Custom({
        order: 1,
        key: 'cboColumn',
        template: templeteForm['ngSelectTpl'],
        label: 'Columna:',
        placeholder: 'Seleccione la columna por la cual desea filtrar.',
        options: optionsOther ? optionsOther['columns'] ? optionsOther['columns'] : [] : [],
        value: data ? data.columna ? data.columna : null : null,
        validations: {
          validators: [Validators.required]
        },
      }),
      new Dropdown({
        order: 2,
        key: 'cboOperador',
        label: 'Operador del filtro:',
        options: optionsOther ? optionsOther['optOperatios'] ? optionsOther['optOperatios'] : [] : [],
        value: data ? data.operador ? data.operador : null : null,
        validations: {
          validators: [Validators.required]
        },
      }),
      new Dropdown({
        order: 2,
        key: 'cboTipoValor',
        label: 'Tipo valor:',
        options: [
          {key: 1, value: 'Valor de formulario'},
          {key: 2, value: 'Valor especifico'}
        ],
        value: data ? data.field ? 1 : 2 : null,
        validations: {
          validators: [Validators.required]
        },
      }),
      new Container({
        class: 'form-row',
        order: 3,
        controls: [
          new Custom({
            size: 'col-12',
            key: 'cboField',
            template: templeteForm['ngSelectGeneral'],
            label: 'Campo:',
            placeholder: 'Seleccione el campo del valor del filtro.',
            options: optionsOther ? optionsOther['fields'] ? optionsOther['fields'] : [] : [],
            value: data ? data.field ? data.field : null : null,
            validations: {
              validators: [Validators.required]
            },
            condictions: [
              {
                campoDepende: 'cboOperador',
                siEs: 'Diferente',
                valor: 'IS NOT NULL',
                accion: 'Mostrar',
                operadorCondicion: 'Y'
              },
              {
                campoDepende: 'cboOperador',
                siEs: 'Diferente',
                valor: 'IS NULL',
                accion: 'Mostrar',
                operadorCondicion: 'Y'
              },
              {
                campoDepende: 'cboTipoValor',
                siEs: 'Igual',
                valor: 1,
                accion: 'Mostrar'
              }
            ],
          }),
        ],
      }),
      new Textbox({
        order: 4,
        key: 'txtValor',
        label: 'Valor del filtro:',
        placeholder: 'Ingrese el valor por el cual desea filtrar.',
        value: data ? data.valor ? data.valor : null : null,
        validations: {
          validators: [Validators.required]
        },
        condictions: [
          {
            campoDepende: 'cboOperador',
            siEs: 'Diferente',
            valor: 'IS NOT NULL',
            accion: 'Mostrar',
            operadorCondicion: 'Y'
          },
          {
            campoDepende: 'cboOperador',
            siEs: 'Diferente',
            valor: 'IS NULL',
            accion: 'Mostrar',
            operadorCondicion: 'Y'
          },
          {
            campoDepende: 'cboTipoValor',
            siEs: 'Igual',
            valor: 2,
            accion: 'Mostrar'
          },
        ],
      }),
      new Custom({
        order: 5,
        key: 'cboconditional',
        label: 'Condicional siguiente:',
        template: templeteForm['ngSelectGeneral'],
        placeholder: 'Seleccione el condicional para el siguiente filtro',
        options: [
          {key: 'Y', value: 'Y'},
          {key: 'O', value: 'O'},
        ],
        value: data ? data.condicional ? data.condicional : null : null,
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/teacher/master-structure/filters-form-master/shared/filters-form-master.form.service.ts